@if (entry?.base?.display) {
  <div>
    <app-producer-file-upload></app-producer-file-upload>
  </div>
}